import { server } from "../../server";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import * as XLSX from "xlsx";
import {
  classList,
  departmentList,
  designationList,
  houseList,
  sectionList,
} from "../../utils";
import { Link } from "react-router-dom";
import CustomMultiSelect from "../../components/CustomMultiSelect";

function SendPushNotification() {
  const [sentEmail, setSentEmail] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const recordsPerPage = 10;
  const todayDate = new Date().toISOString().split("T")[0];
  const [submitLoading, setSubmitLoading] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    message: "",
    category: "All",
    studentFilter: {
      studentClass: [],
      section: [],
      gender: [],
      house: [],
      busNo: [],
    },
    staffFilter: {
      staffCategory: [],
      designation: [],
      department: [],
      gender: [],
    },
  });

  const allClassOptions = classList.map((item) => ({
    value: item,
    label: item,
  }));
  const allSectionOptions = sectionList.map((item) => ({
    value: item,
    label: item,
  }));
  const allBusNoOptions = Array.from({ length: 40 }, (_, i) => ({
    value: (i + 1).toString().padStart(2, "0"),
    label: (i + 1).toString().padStart(2, "0"),
  }));
  const allHouseOptions = houseList.map((item) => ({
    value: item,
    label: item,
  }));
  const allGenderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];
  const allDesignationOptions = designationList.map((item) => ({
    value: item,
    label: item,
  }));
  const allDepartmentOptions = departmentList.map((item) => ({
    value: item,
    label: item,
  }));

  const withSelectAll = (options) => [
    { value: "*", label: "Select All" },
    ...options,
  ];

  const staffCategoryOptions = [
    { label: "Teaching", value: "Teaching" },
    { label: "Non Teaching", value: "Non Teaching" },
    { label: "Supporting Staff", value: "Supporting Staff" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiSelectChange = (selected, keyPath) => {
    const isSelectAll = selected?.some((s) => s.value === "*");

    let newSelected = selected || [];

    if (isSelectAll) {
      const actualOptions =
        keyPath[1] === "designation"
          ? allDesignationOptions
          : keyPath[1] === "department"
            ? allDepartmentOptions
            : keyPath[1] === "studentClass"
              ? allClassOptions
              : keyPath[1] === "section"
                ? allSectionOptions
                : keyPath[1] === "busNo"
                  ? allBusNoOptions
                  : keyPath[1] === "house"
                    ? allHouseOptions
                    : keyPath[1] === "gender"
                      ? allGenderOptions
                      : [];

      newSelected = actualOptions;
    }

    const values = newSelected.map((s) => s.value);

    setFormData((prev) => {
      const updated = { ...prev };
      if (keyPath.length === 2) {
        updated[keyPath[0]] = {
          ...prev[keyPath[0]],
          [keyPath[1]]: values,
        };
      } else {
        updated[keyPath[0]] = values;
      }
      return updated;
    });
  };

  const getSelectedOptions = (allOptions, selectedValues) => {
    return allOptions.filter((opt) => selectedValues.includes(opt.value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title || !formData.message) {
      toast.error("Title and Message are Required", { position: "top-right" });
      return;
    }

    setSubmitLoading(true);
    try {
      const payload = {
        title: formData.title,
        message: formData.message,
        category: formData.category,
        studentFilter: {
          studentClass: formData.studentFilter.studentClass,
          section: formData.studentFilter.section,
          gender: formData.studentFilter.gender,
          house: formData.studentFilter.house,
          busNo: formData.studentFilter.busNo,
        },
        staffFilter: {
          staffCategory: formData.staffFilter.staffCategory,
          designation: formData.staffFilter.designation,
          department: formData.staffFilter.department,
          gender: formData.staffFilter.gender,
        },
      };

      await axios.post(`${server}SendNotificationByChoice`, payload, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      toast.success("Notification Sent", { position: "top-right" });
      fetchNotice();
      document.querySelector('[data-bs-dismiss="modal"]')?.click();
      setFormData({
        title: "",
        message: "",
        category: "All",
        studentFilter: {
          studentClass: [],
          section: [],
          gender: [],
          house: [],
          busNo: [],
        },
        staffFilter: {
          staffCategory: [],
          designation: [],
          department: [],
          gender: [],
        },
      });
    } catch (error) {
      toast.error("Please Try Again", { position: "top-right" });
    } finally {
      setSubmitLoading(false);
    }
  };

  const fetchNotice = async () => {
    try {
      const response = await axios.get(`${server}/GetAllNotifications`, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
      });
      if (response.data && Array.isArray(response.data.data)) {
        setSentEmail(response.data.data);
      } else {
        console.error("Invalid data format from API", response.data);
      }
    } catch (error) {
      console.error("Error fetching bus details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotice();
  }, []);

  // Filter
  const filteredRecords = sentEmail.filter((scholarship) => {
    const searchLower = searchTerm.toLowerCase();

    return Object.values(scholarship).some((value) => {
      if (typeof value === "string") {
        return value.toLowerCase().includes(searchLower);
      } else if (typeof value === "object" && value !== null) {
        return Object.values(value).some(
          (subValue) =>
            typeof subValue === "string" &&
            subValue.toLowerCase().includes(searchLower),
        );
      }
      return false;
    });
  });

  // ✅ Reset pagination when searching
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // ✅ Apply pagination AFTER filtering
  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord,
  );

  // Page Navigation
  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleExportAllEmailsExcel = () => {
    if (!sentEmail || sentEmail.length === 0) {
      toast.error("No Email records to export.");
      return;
    }

    const sheetData = sentEmail.map((email) => ({
      Title: email.title || "",
      Class: email.class || "",
      Section: email.section || "",
      "Bus No": email.busNo || "",
      House: email.house || "",
      Gender: email.gender || "",
      Message: email.message || "",
      Attachment: email.attachment || "",
      Date: email.createdAt
        ? new Date(email.createdAt).toLocaleDateString("en-GB")
        : "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "All Emails");

    const today = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(workbook, `AllEmails_${today}.xlsx`);
    toast.success("Report Generated");
  };

  const handleExportEmailsWithAttachmentExcel = () => {
    if (!sentEmail || sentEmail.length === 0) {
      toast.error("No Email records to export.");
      return;
    }

    const emailsWithAttachment = sentEmail.filter(
      (email) => email.attachment && email.attachment.trim() !== "",
    );

    if (emailsWithAttachment.length === 0) {
      toast.warning("No emails with attachments found.");
      return;
    }

    const sheetData = emailsWithAttachment.map((email) => ({
      Title: email.title || "",
      Class: email.class || "",
      Section: email.section || "",
      "Bus No": email.busNo || "",
      House: email.house || "",
      Gender: email.gender || "",
      Message: email.message || "",
      Attachment: email.attachment,
      Date: email.createdAt
        ? new Date(email.createdAt).toLocaleDateString("en-GB")
        : "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Emails With Attachment");

    const today = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(workbook, `Emails_WithAttachment_${today}.xlsx`);
    toast.success("Report Generated");
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div
            class="modal fade gd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <form onSubmit={handleSubmit}>
                  <div className="modal-header d-flex justify-content-between">
                    <h5
                      className="modal-title fs-4"
                      id="exampleModalToggleLabel"
                    >
                      Compose Push Notification
                    </h5>
                    <div className="d-flex align-items-center">
                      <span className="badge bg-success-soft me-3 px-3">
                        Editable
                      </span>
                      <div className="form-check form-switch me-4">
                        <input
                          type="checkbox"
                          className="form-check-input m-0"
                          checked
                          readOnly
                        />
                      </div>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                  </div>

                  <div className="modal-body">
                    <div className="row g-2 mb-2">
                      {/* Title */}
                      <div className="col-lg-6 col-12">
                        <label className="form-label mb-1 ms-3">
                          Title <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control text-dark"
                          name="title"
                          value={formData.title}
                          onChange={handleChange}
                          placeholder="Enter Title"
                          required
                        />
                      </div>

                      {/* Category */}
                      <div className="col-lg-6 col-12">
                        <label className="form-label mb-1 ms-3">
                          Category <span className="text-danger">*</span>
                        </label>
                        <Select
                          options={[
                            { label: "All", value: "All" },
                            { label: "Student", value: "Student" },
                            { label: "Staff", value: "Staff" },
                          ]}
                          value={{
                            label: formData.category,
                            value: formData.category,
                          }}
                          onChange={(selected) =>
                            setFormData((prev) => ({
                              ...prev,
                              category: selected?.value || "",
                            }))
                          }
                          placeholder="Select Category"
                        />
                      </div>

                      {/* Message */}
                      <div className="col-6">
                        <label className="form-label mb-1 ms-3">
                          Message <span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control text-dark"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          placeholder="Enter Message"
                          rows="4"
                          required
                        ></textarea>
                      </div>

                      {/* Student Filters (Visible Only When Student Selected) */}
                      {formData.category === "Student" && (
                        <>
                          <div className="col-lg-6 col-12">
                            <label className="form-label mb-1 ms-3">
                              Class
                            </label>
                            <CustomMultiSelect
                              options={allClassOptions}
                              withSelectAllFn={withSelectAll}
                              value={getSelectedOptions(
                                allClassOptions,
                                formData.studentFilter.studentClass,
                              )}
                              handleMultiSelectChange={handleMultiSelectChange}
                              path={["studentFilter", "studentClass"]}
                              placeholder="Select Class"
                            />
                          </div>
                          <div className="col-lg-6 col-12">
                            <label className="form-label mb-1 ms-3">
                              Section
                            </label>
                            <CustomMultiSelect
                              options={allSectionOptions}
                              withSelectAllFn={withSelectAll}
                              value={getSelectedOptions(
                                allSectionOptions,
                                formData.studentFilter.section,
                              )}
                              handleMultiSelectChange={handleMultiSelectChange}
                              path={["studentFilter", "section"]}
                              placeholder="Select Section"
                            />
                          </div>
                          <div className="col-lg-6 col-12">
                            <label className="form-label mb-1 ms-3">
                              Bus No
                            </label>
                            <CustomMultiSelect
                              options={allBusNoOptions}
                              withSelectAllFn={withSelectAll}
                              value={getSelectedOptions(
                                allBusNoOptions,
                                formData.studentFilter.busNo,
                              )}
                              handleMultiSelectChange={handleMultiSelectChange}
                              path={["studentFilter", "busNo"]}
                              placeholder="Select Bus Number"
                            />
                          </div>
                          <div className="col-lg-6 col-12">
                            <label className="form-label mb-1 ms-3">
                              House
                            </label>
                            <CustomMultiSelect
                              options={allHouseOptions}
                              withSelectAllFn={withSelectAll}
                              value={getSelectedOptions(
                                allHouseOptions,
                                formData.studentFilter.house,
                              )}
                              handleMultiSelectChange={handleMultiSelectChange}
                              path={["studentFilter", "house"]}
                              placeholder="Select House"
                            />
                          </div>
                          <div className="col-lg-6 col-12">
                            <label className="form-label mb-1 ms-3">
                              Gender
                            </label>
                            <CustomMultiSelect
                              options={allGenderOptions}
                              withSelectAllFn={withSelectAll}
                              value={getSelectedOptions(
                                allGenderOptions,
                                formData.studentFilter.gender,
                              )}
                              handleMultiSelectChange={handleMultiSelectChange}
                              path={["studentFilter", "gender"]}
                              placeholder="Select Gender"
                            />
                          </div>
                        </>
                      )}

                      {/* Staff Filters (Visible Only When Staff Selected) */}
                      {formData.category === "Staff" && (
                        <>
                          <div className="col-lg-6 col-12">
                            <label className="form-label mb-1 ms-3">
                              Staff Category
                            </label>
                            <CustomMultiSelect
                              options={staffCategoryOptions}
                              withSelectAllFn={withSelectAll}
                              value={getSelectedOptions(
                                staffCategoryOptions,
                                formData.staffFilter.staffCategory,
                              )}
                              handleMultiSelectChange={handleMultiSelectChange}
                              path={["staffFilter", "staffCategory"]}
                              placeholder="Select Staff Category"
                            />
                          </div>
                          <div className="col-lg-6 col-12">
                            <label className="form-label mb-1 ms-3">
                              Designation
                            </label>
                            <CustomMultiSelect
                              options={allDesignationOptions}
                              withSelectAllFn={withSelectAll}
                              value={getSelectedOptions(
                                allDesignationOptions,
                                formData.staffFilter.designation,
                              )}
                              handleMultiSelectChange={handleMultiSelectChange}
                              path={["staffFilter", "designation"]}
                              placeholder="Select Designation"
                            />
                          </div>
                          <div className="col-lg-6 col-12">
                            <label className="form-label mb-1 ms-3">
                              Department
                            </label>
                            <CustomMultiSelect
                              options={allDepartmentOptions}
                              withSelectAllFn={withSelectAll}
                              value={getSelectedOptions(
                                allDepartmentOptions,
                                formData.staffFilter.department,
                              )}
                              handleMultiSelectChange={handleMultiSelectChange}
                              path={["staffFilter", "department"]}
                              placeholder="Select Department"
                            />
                          </div>
                          <div className="col-lg-6 col-12">
                            <label className="form-label mb-1 ms-3">
                              Gender
                            </label>
                            <CustomMultiSelect
                              options={allGenderOptions}
                              withSelectAllFn={withSelectAll}
                              value={getSelectedOptions(
                                allGenderOptions,
                                formData.staffFilter.gender,
                              )}
                              handleMultiSelectChange={handleMultiSelectChange}
                              path={["staffFilter", "gender"]}
                              placeholder="Select Gender"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="modal-footer d-flex justify-content-between py-2">
                    <div>
                      <button
                        type="button"
                        className="btn btn-secondary px-3 me-1 rounded-pill"
                        data-bs-dismiss="modal"
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                      <button
                        type="submit"
                        class="btn btn-primary px-5 rounded-pill fw-normal"
                        disabled={submitLoading}
                      >
                        {submitLoading ? (
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          ></div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="">
            <div class="container-fluid my-3 px-3">
              <div className="row g-2">
                <div className="col-lg-8">
                  <div class="table-responsive border-0 overflow-y-hidden bg-white rounded-4">
                    <table class="table mb-0 text-nowrap table-centered">
                      <thead class="table-light">
                        <tr>
                          <th className="w-10">No.</th>
                          <th className="lh-1 w-60">
                            Details
                            <i className="bi bi-info-circle ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Displaying Information as per Record
                            </span>
                          </th>
                          <th className="lh-1 w-30">
                            Action
                            <i className="bi bi-person-gear ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Role-Specific Action Panel
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRecords.map((email, index) => (
                          <tr>
                            <td>{indexOfFirstRecord + index + 1}.</td>
                            <td className="lh-sm py-4 text-wrap">
                              <span class="text-dark">Category</span> &mdash;{" "}
                              <span className="text-capitalize">
                                {email.category}
                              </span>
                              <br />
                              <span class="text-dark">
                                Recipients
                              </span> &mdash; {email.recipientsCount}
                              <br />
                              <span class="text-dark">
                                Success
                              </span> &mdash; {email.successCount}
                              <br />
                              <span class="text-dark">
                                Failure
                              </span> &mdash; {email.failureCount}
                              <br />
                              <span class="text-dark">Title</span> &mdash;{" "}
                              {email.title}
                              <br />
                              <span class="text-dark">
                                Message
                              </span> &mdash;{" "}
                              {email.message
                                .split("\n")
                                .map((line, lineIndex) => {
                                  const wordGroups = line
                                    .split(" ")
                                    .reduce((acc, word, index) => {
                                      const last = acc.length - 1;
                                      if (index % 8 === 0) {
                                        acc.push([word]);
                                      } else {
                                        acc[last].push(word);
                                      }
                                      return acc;
                                    }, []);

                                  return (
                                    <div key={lineIndex}>
                                      {wordGroups.map((group, groupIndex) => (
                                        <React.Fragment key={groupIndex}>
                                          {group.join(" ")}
                                          <br />
                                        </React.Fragment>
                                      ))}
                                    </div>
                                  );
                                })}
                              <br />
                              <span class="text-dark">Date</span> &mdash;{" "}
                              {email.createdAt
                                ? new Date(email.createdAt).toLocaleDateString(
                                    "en-GB",
                                  )
                                : ""}
                            </td>
                            <td>
                              <div className="d-flex flex-column gap-1 width-fit-content">
                                <span class="badge bg-success-soft cursor-pointer px-4 rounded-3 btn-py-sm">
                                  Sent
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div class="">
                    <div className="mb-3">
                      <div className="d-flex bg-white justify-content-between rounded-4">
                        <form
                          className="d-flex align-items-center"
                          onSubmit={(e) => e.preventDefault()}
                        >
                          <span className="position-absolute ps-3 search-icon">
                            <i className="bi bi-filter-circle-fill ms-1" />
                          </span>
                          <input
                            type="search"
                            className="form-control ps-7 rounded-3 border-0 rounded-4"
                            placeholder="Filter Data"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </form>
                        <Link
                          data-bs-toggle="modal"
                          data-bs-target=".gd-example-modal-lg"
                          class="btn btn-warning px-5 fs-6 fw-medium rounded-4 fit-content"
                        >
                          Compose Notification
                        </Link>
                      </div>
                      <div className="mt-2 ms-4">
                        <nav aria-label="breadcrumb">
                          <ol class="breadcrumb pe-3">
                            <li class="breadcrumb-item">
                              <a href="#">Communicate</a>
                            </li>
                            <li
                              class="breadcrumb-item active"
                              aria-current="page"
                            >
                              Send Push Notification
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>

                    <div className="p-4 bg-white rounded-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          {loading ? (
                            <div
                              className="spinner-border text-dark data-loader-spinner"
                              role="status"
                            ></div>
                          ) : (
                            <img src="/assets/images/folder.svg" />
                          )}
                          <p className="my-0 fw-semibold lh-1 fs-5 text-dark mx-3">
                            Send Push Notification
                            <br />
                            <span className="text-secondary fs-6 fw-medium lh-sm">
                              0.2 MB Size
                            </span>
                          </p>
                        </div>
                        <span className="badge bg-pink rounded-3 px-4 py-2 me-1 mt-1 cursor-pointer">
                          Export
                        </span>
                      </div>

                      <div class="px-4 py-2 mt-3 bg-light rounded-4">
                        <li className="list-group-item px-0">
                          <a
                            className="d-flex align-items-center text-inherit mb-0 justify-content-between"
                            data-bs-toggle="collapse"
                            href="#specifications"
                            role="button"
                            aria-expanded="false"
                            aria-controls="specifications"
                          >
                            <p className="m-0 fw-medium lh-sm text-dark">
                              Download Report
                            </p>
                            <span className="chevron-arrow ms-4">
                              <i className="bi bi-chevron-down fs-4" />
                            </span>
                          </a>
                          <div
                            className="collapse"
                            id="specifications"
                            data-bs-parent="#ecommerceAccordion"
                          >
                            <div className="py-3">
                              <div class="rounded-4 d-flex flex-wrap">
                                <span
                                  onClick={handleExportAllEmailsExcel}
                                  class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  All Mails
                                </span>
                                <span
                                  onClick={
                                    handleExportEmailsWithAttachmentExcel
                                  }
                                  class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  Mails With Attachment
                                </span>
                                <span class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1">
                                  Date Wise E-Mail
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>
                    </div>

                    <div className="my-4">
                      <nav>
                        <ul className="pagination justify-content-center mb-0">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={prevPage}>
                              <i className="bi bi-chevron-left"></i>
                            </button>
                          </li>

                          {(() => {
                            const pageNumbers = [];
                            pageNumbers.push(1);

                            if (currentPage > 3) {
                              pageNumbers.push("left-ellipsis");
                            }

                            if (
                              currentPage !== 1 &&
                              currentPage !== totalPages
                            ) {
                              pageNumbers.push(currentPage);
                            }

                            if (currentPage < totalPages - 2) {
                              pageNumbers.push("right-ellipsis");
                            }

                            if (totalPages > 1) {
                              pageNumbers.push(totalPages);
                            }

                            return pageNumbers.map((page, index) => {
                              if (
                                page === "left-ellipsis" ||
                                page === "right-ellipsis"
                              ) {
                                return (
                                  <li
                                    key={index}
                                    className="page-item disabled"
                                  >
                                    <span className="page-link">...</span>
                                  </li>
                                );
                              }

                              return (
                                <li
                                  key={index}
                                  className={`page-item ${
                                    currentPage === page ? "active" : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(page)}
                                  >
                                    {page}
                                  </button>
                                </li>
                              );
                            });
                          })()}

                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={nextPage}>
                              <i className="bi bi-chevron-right"></i>
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default SendPushNotification;
